import React from "react"
import { IImageProps } from "../util/interface"

const CustomIcon: React.FC<IImageProps> = ({ path, alt }) => (
  <img className={"mr-1"} src={path} alt={alt} />
)

export default CustomIcon
